import { ServiceDataFields } from './service-data-fields.enum';

export const rhFieldSet = [
  ServiceDataFields.PregnancyInformation,
  ServiceDataFields.DueDate,
  ServiceDataFields.PregnancyType,
  ServiceDataFields.PatientHistoryInformation,
  ServiceDataFields.HistoryOfCancer,
  ServiceDataFields.HumanSerumAlbuminTherapy,
  ServiceDataFields.CellularImmunotherapy,
  ServiceDataFields.StemCellTherapy,
  ServiceDataFields.TransplantSurgery,
  ServiceDataFields.BloodTransfusion,
  ServiceDataFields.RhdStatus,
  ServiceDataFields.AdditionalPatientInformation,
  ServiceDataFields.Weight,
  ServiceDataFields.Height,
  ServiceDataFields.DocumentNumber,
];
